import React from "react";
import {Col, Form, FormGroup, Input, Label, Row} from "reactstrap";

import {FL_DESCRIPTION,  FL_TITLE} from "../../../components/i18n/formLabels";
import {
    PH_DESCRIPTION,
    PH_TITLE
} from "../../../components/i18n/placeHolders";
import {LangController} from "../../../components/tabs/langController";


export const DishDrinkLangs = props => {

    const setDataDefault = (activeLangs, setLangChilds) => {
        const items = activeLangs.map( lang => ({
            id: '',
            lang: { id:lang?.id, name:lang?.name, showOrder: lang?.showOrder },
            title: '',
            shortDescription: '',
            longDescription: '',
        }) )
        setLangChilds(items);
    }

    const getFormulary = (child, index, disableInputs, onInputChange) => {
        return (
            <Form>
                <Row>
                    <Col md={"12"}>
                        <FormGroup>
                            <Label>{FL_TITLE}</Label>
                            <Input
                                type="text"
                                name="title"
                                placeholder={PH_TITLE}
                                value= { child.title }
                                onChange={e => onInputChange(e, child.lang)}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={"12"}>
                        <FormGroup>
                            <Label>{ FL_DESCRIPTION }</Label>
                            <Input
                                type="textarea"
                                rows={"8"}
                                name="longDescription"
                                placeholder={ PH_DESCRIPTION }
                                value= { child.longDescription }
                                onChange={e => onInputChange(e, child.lang)}
                            />
                        </FormGroup>
                    </Col>
                </Row>
            </Form>
        );
    }

    return(<LangController
        langs={props.langs}
        setLangs={props.setLangs}
        getFormulary={getFormulary}
        setDataDefault={setDataDefault}
        translatableLangs={props.translatableLangs}
    />)

}